import React, { useState } from "react";
import dynamicFunction from "../utils/dynamicfunction";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import ViewReverse from "./ViewReverse";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import { cn } from "../utils/utils";

const CustomInput = ({
  type = "text",
  value,
  onChange,
  isFullborder = true,
  isRounded = true,
  placeholder,
  isError = false,
  className,
  label,
  labelColor,
  divClasses,
  isRequired = false,
  errorMessage,
  isDisabled = false,
  width = "w-full",
  isPassword,
  minLength,
  maxLength,
  inputClassName,
  pattern,
  border,
  onPressEnter,
  canEnterSpace = true,
  props,
  labelDivClass = false,
  isLabelHeight = false,
}) => {
  const { TextWeight, TextAlign } = dynamicFunction();
  const [isSecure, setIsSecure] = useState(true);

  return (
    <div className={`${width} ${divClasses} ${isDisabled && "opacity-50"} flex flex-col`}>
      {label && (
        <div className={cn(labelDivClass ? labelDivClass : isLabelHeight ? 'md:h-9' : "h-6")} >
          <Text
            text={label}
            size={fontSizes.h14}
            color={isError ? "text-red-500" : labelColor}
            className={cn('leading-4', isLabelHeight && 'mb-1')}
            isRequired={isRequired}
            isTruncate={false}
          />
        </div>
      )}
      <ViewReverse
        className={`px-3 py-2 ${
          border ?? (isFullborder ? "border" : "border-b-2")
        } ${isError ? "border-red-600" : "border-grey"} ${
          isRounded ? "rounded-md" : ""
        } w-full h-[40px] ${className}`}
      >
        <input
          type={isPassword ? (isSecure ? "password" : "text") : type}
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          placeholder={placeholder}
          className={cn('outline-none w-full text-sm bg-transparent', TextWeight.light, TextAlign, inputClassName)}
          minLength={minLength}
          maxLength={maxLength}
          pattern={pattern}
          onKeyDown={(e) => {
            if (e.key === " " && !canEnterSpace) {
              e.preventDefault();
              return;
            }
            e.key === "Enter" && onPressEnter && onPressEnter();
          }}
          onInput={(e) => {
            if (!canEnterSpace) {
              const value = e.target.value;
              if (value.endsWith(". ")) {
                e.target.value = value.slice(0, -2);
              }
            }
          }}
          {...props}
        />
        {isPassword && (
          <>
            <ReactSVG
              src={isSecure ? icons.hidePassword : icons.showPassword}
              className="cursor-pointer"
              onClick={() => !isDisabled && setIsSecure(!isSecure)}
            />
          </>
        )}
      </ViewReverse>
      {errorMessage && (
        <Text
          text={errorMessage}
          color="text-red"
          className={"mt-2"}
          weight={TextWeight.light}
        />
      )}
    </div>
  );
};

export default CustomInput;
